export default {
  calendarDomain: 'https://calendar.apps.secureserver.net'
};
